import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-form4-view',
  templateUrl: './form4-view.component.html',
  styleUrls: ['./form4-view.component.css']
})
export class Form4ViewComponent implements OnInit {
  title="Form 4: Form for Training certificate";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/form4-view/form4-view.component.ts